module.exports = __webpack_public_path__ + "0680f18e908b01dd6249cf1593c7c495.webm";


//////////////////
// WEBPACK FOOTER
// ./assets/tutorials/computer-big.webm
// module id = QqNa
// module chunks = 0